import { FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon } from "../assets/icons";
import { BNILogo, BRILogo, CIMBLogo, DanamonLogo, MandiriLogo, PermataLogo } from "../assets/images";
const startYear = 1945
const currentYear = new Date().getFullYear();
const whatsappNumber = "62081110150313"
const years = Array(currentYear - startYear + 1).fill(null).map((_, index) => ({
  value: currentYear - index,
  label: currentYear - index
}))

const months = [
  {
    value: "1",
    label: "Januari",
  },
  {
    value: "2",
    label: "Februari",
  },
  {
    value: "3",
    label: "Maret",
  },
  {
    value: "4",
    label: "April",
  },
  {
    value: "5",
    label: "Mei",
  },
  {
    value: "6",
    label: "Juni",
  },
  {
    value: "7",
    label: "Juli",
  },
  {
    value: "8",
    label: "Agustus",
  },
  {
    value: "9",
    label: "September",
  },
  {
    value: "10",
    label: "Oktober",
  },
  {
    value: "11",
    label: "November",
  },
  {
    value: "12",
    label: "Desember",
  },
];
const days = Array(31).fill(null).map((_, index) => ({
  value: index + 1,
  label: index + 1
}))

const socialMediaList = [
  { name: 'fb', icon: FacebookIcon, url: 'https://www.google.co.id' },
  { name: 'yt', icon: YoutubeIcon, url: '' },
  { name: 'ig', icon: InstagramIcon, url: '' },
  { name: 'li', icon: LinkedinIcon, url: '' },
]

const regexForNumber = /.*[0-9].*/;
const regexForUppercase = /.*[A-Z].*/;
const regexForSpecialCharacter = /.*[^A-Za-z0-9].*/;

const handleBadgeType = {
  'PENDING': 'warning',
  'PAID': 'success',
  'EXPIRE': 'danger'
}
const handleBadgeLabel = {
  'PENDING': 'Menunggu Pembayaran',
  'PAID': 'Lunas',
  'EXPIRE': 'Wanprestasi'
}

const bankList = [
  // {
  //   label: 'Bersama Virtual Account',
  //   name: 'Bersama',
  //   value: '04_VA_BERSAMA'
  // },
  // {
  //   label: 'BCA Virtual Account',
  //   name: 'BCA',
  //   value: '05_VA_BCA'
  // },
  {
    label: 'Mandiri Virtual Account',
    name: 'Mandiri',
    value: '06_VA_MANDIRI',
    logo: MandiriLogo
  },
  {
    label: 'BNI Virtual Account',
    name: 'BNI',
    value: '07_VA_BNI',
    logo: BNILogo
  },
  {
    label: 'BRI Virtual Account',
    name: 'BRI',
    value: '08_VA_BRI',
    logo: BRILogo
  },
  {
    label: 'Danamon Virtual Account',
    name: 'Danamon',
    value: '17_VA_DANAMON',
    logo: DanamonLogo,
  },
  {
    label: 'CIMB Niaga Virtual Account',
    name: 'Cimb Niaga',
    value: '18_VA_NIAGA',
    logo: CIMBLogo,
  },
  {
    label: 'Permata Virtual Account',
    name: 'Permata',
    value: '19_VA_PERMATA',
    logo: PermataLogo
  },
  {
    label: 'Transfer Bank',
    name: 'manual',
    value: '99_MANUAL'
  }
]

export {
  days,
  months,
  years,
  bankList,
  socialMediaList,
  regexForNumber,
  regexForUppercase,
  regexForSpecialCharacter,
  handleBadgeType,
  handleBadgeLabel,
  whatsappNumber
}